import React from 'react'
import styles from './Success.module.css'

function Success() {
  return <div className={styles.Wrapper}>Success! Purchase completed</div>
}

export default Success
